import React, { useEffect, useState } from "react";
import Layout from "../layouts/Layout";
import { connect } from "react-redux";
import { Container } from "react-bootstrap";
import { Faq } from "../components/Homepage";
import { setLoader, toggleChooseCar } from "redux/actions/globalAction";
import ChooseCarMobile from "components/common/ChooseCarMobile";

const FAQ = ({ apiData, profile,setLoader,toggleChooseCar }) => {
  useEffect(() => {
    setLoader(false);
    toggleChooseCar(false);
  }, []);
  return (
    <Layout title={"FAQ"}>
      <Container style={{marginTop:"15px"}}>
        <Faq showFull />
      </Container>
    </Layout>
  );
};

const mapStateToProps = (state) => {
  return {
    apiData: state.apiData,
    globalData: state.globalData,
    profile: state.profile,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setLoader: (flag) => {
      dispatch(setLoader(flag));
    },
    toggleChooseCar: (stage) => {
      dispatch(toggleChooseCar(stage));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FAQ);
